<template>
  <main class="services-page">
    <section class="services-hero">
      <div class="container">
        <div class="services-hero-grid">
          <div>
            <h6 class="section-title text-start text-primary text-uppercase">Hizmetlerimiz</h6>
            <h1>Ankara'daki Ağrılılar için dernek, iş, bilet, firma ve dayanışma ağı</h1>
            <p>
              Ankara Ağrılılar Derneği olarak Ağrı Merkez, Doğubayazıt, Patnos, Diyadin,
              Eleşkirt, Tutak, Taşlıçay ve Hamur kökenli hemşehrilerimizi; Mamak, Keçiören,
              Sincan, Etimesgut, Yenimahalle, Altındağ, Pursaklar ve Ankara'nın tüm ilçelerinde
              aynı iletişim çatısında buluşturuyoruz.
            </p>
          </div>

          <div class="services-contact-card">
            <span>Hızlı iletişim</span>
            <strong>0507 921 7404</strong>
            <a :href="generalWhatsappUrl" target="_blank" rel="noopener" class="btn btn-primary">
              <i class="fab fa-whatsapp me-2"></i>WhatsApp'tan Yaz
            </a>
          </div>
        </div>

        <div class="seo-keywords">
          <span>Ankara Ağrılılar Derneği</span>
          <span>Ankara Doğubayazıtlılar</span>
          <span>Ankara Patnoslular</span>
          <span>Mamak Ağrılılar</span>
          <span>Keçiören Ağrılılar</span>
          <span>Ankara Ağrılı firmalar</span>
          <span>Ağrılı hemşehri dayanışması</span>
        </div>
      </div>
    </section>

    <section class="services-main">
      <div class="container">
        <div class="services-layout">
          <aside class="services-side">
            <h2>Kimler için?</h2>
            <p>
              Ankara'da dernek, WhatsApp grubu, Ağrı otobüs bileti, iş, firma, usta,
              taziye veya hemşehri arayan herkes için güvenilir bir bağlantı noktası oluşturuyoruz.
            </p>
            <div class="district-links">
              <router-link to="/ilceler/dogubayazit">Doğubayazıtlılar</router-link>
              <router-link to="/ilceler/patnos">Patnoslular</router-link>
              <router-link to="/ilceler/agri-merkez">Ağrı Merkez</router-link>
              <router-link to="/firmalar">Ağrılı Firmalar</router-link>
            </div>
          </aside>

          <div class="services-list">
            <article v-for="service in services" :key="service.title" class="service-card">
              <div class="service-icon">
                <i :class="`fa ${service.icon}`"></i>
              </div>
              <div class="service-content">
                <h2>{{ service.title }}</h2>
                <p>{{ service.description }}</p>
                <div class="service-tags">
                  <span v-for="tag in service.tags" :key="tag">{{ tag }}</span>
                </div>
              </div>
              <a :href="whatsappUrl(service.title)" target="_blank" rel="noopener" class="service-action">
                <i class="fab fa-whatsapp"></i>
                Bilgi Al
              </a>
            </article>
          </div>
        </div>
      </div>
    </section>

    <section class="search-intent-section">
      <div class="container">
        <div class="intent-panel">
          <div>
            <h2>Ankara'da yaşayan Ağrılılar ne arıyor?</h2>
            <p>
              Derneğimiz sadece bir tabela değil; Ankara'da yaşayan Ağrılıların günlük hayatta
              ihtiyaç duyduğu bilgi, bağlantı ve güven ağıdır. Mamak, Keçiören, Sincan, Etimesgut,
              Yenimahalle, Altındağ, Pursaklar ve Çankaya gibi ilçelerde yaşayan hemşehrilerimizi
              tek iletişim çatısında buluşturmayı hedefliyoruz.
            </p>
          </div>

          <div class="intent-grid">
            <span v-for="term in searchTerms" :key="term">{{ term }}</span>
          </div>
        </div>
      </div>
    </section>
  </main>
</template>

<script setup>
const searchTerms = [
  'Ankara Ağrılılar Derneği',
  'Ankara Ağrılılar WhatsApp grubu',
  'Ankara Doğubayazıtlılar',
  'Ankara Patnoslular',
  'Mamak Ağrılılar',
  'Keçiören Ağrılılar',
  'Sincan Ağrılılar',
  'Etimesgut Ağrılılar',
  'Yenimahalle Ağrılılar',
  'Altındağ Ağrılılar',
  'Pursaklar Ağrılılar',
  'Çankaya Ağrılılar',
  'Ankara Ağrı otobüs bileti',
  'Ankara Ağrı bilet',
  'Ankara Doğubayazıt otobüs bileti',
  'Ankara Patnos otobüs bileti',
  'Ankara Ağrılı firmalar',
  'Ankara Ağrılı esnaflar',
  'Ağrılı usta Ankara',
  'Ağrılı iş insanları Ankara',
  'Ankara Ağrılı iş ilanları',
  'Ankara Ağrılı eleman arayanlar',
  'Ankara taziye duyurusu Ağrılı',
  'Ankara Ağrılı düğün duyurusu',
  'Ankara Ağrılı öğrenci dayanışması'
]

const services = [
  {
    icon: 'fa-briefcase',
    title: 'İş Bulma ve Eleman Yönlendirme',
    description: 'İş arayan hemşehrilerimizi Ankara’daki Ağrılı firma sahipleriyle buluşturuyor, güvenilir eleman arayan işletmelere doğru kişilere ulaşmaları için destek oluyoruz.',
    tags: ['İş arayanlar', 'Firmalar', 'Ankara']
  },
  {
    icon: 'fa-store',
    title: 'Firma Tanıtımı ve Müşteri Kazanma',
    description: 'Ağrılı esnafların, Doğubayazıtlı ve Patnoslu firma sahiplerinin daha görünür olması için web sitemizde firma rehberi, kategori araması, telefon ve WhatsApp iletişimi sağlıyoruz.',
    tags: ['Firma rehberi', 'Müşteri', 'WhatsApp']
  },
  {
    icon: 'fa-hand-holding-heart',
    title: 'Sosyal Yardım ve Dayanışma',
    description: 'İhtiyaç sahibi aileler, öğrenciler ve zor durumda kalan hemşehrilerimiz için gıda, eğitim, taziye, ziyaret ve dayanışma çalışmalarını organize ediyoruz.',
    tags: ['Sosyal destek', 'Aile', 'Öğrenci']
  },
  {
    icon: 'fa-graduation-cap',
    title: 'Eğitim, Gençlik ve Kariyer',
    description: 'Gençlerimize kariyer rehberliği, eğitim desteği, burs yönlendirmesi, yazılım ve mesleki gelişim alanlarında yol gösterici çalışmalar yapıyoruz.',
    tags: ['Eğitim', 'Kariyer', 'Gençlik']
  },
  {
    icon: 'fa-users',
    title: 'İlçe Hemşehri Buluşmaları',
    description: 'Ankara Doğubayazıtlılar, Ankara Patnoslular, Diyadinliler, Eleşkirtililer, Tutaklılar, Taşlıçaylılar ve Hamurlular için tanışma, toplantı ve kültürel buluşmalar düzenliyoruz.',
    tags: ['Doğubayazıt', 'Patnos', 'Ağrı ilçeleri']
  },
  {
    icon: 'fa-scale-balanced',
    title: 'Danışmanlık ve Güvenilir Yönlendirme',
    description: 'Hukuk, sigorta, sağlık, vize, emlak, inşaat ve benzeri alanlarda hizmet veren güvenilir hemşehri işletmelerine ulaşmayı kolaylaştırıyoruz.',
    tags: ['Danışmanlık', 'Hukuk', 'Vize']
  },
  {
    icon: 'fa-bullhorn',
    title: 'Duyuru, Etkinlik ve Kültürel Faaliyetler',
    description: 'Piknik, toplantı, kültürel gece, tanıtım günü ve sosyal etkinlikleri duyurarak Ankara’daki Ağrılıların birbirinden haberdar olmasını sağlıyoruz.',
    tags: ['Etkinlik', 'Kültür', 'Duyuru']
  },
  {
    icon: 'fa-map-location-dot',
    title: 'Ankara’da Hemşehri Ağı',
    description: 'Yeni gelen hemşehrilerimize adres, konum, firma, iş ve sosyal çevre konusunda pratik bağlantılar sunarak Ankara’ya uyum süreçlerini kolaylaştırıyoruz.',
    tags: ['Ankara', 'Hemşehri ağı', 'İletişim']
  },
  {
    icon: 'fa-ribbon',
    title: 'Taziye ve Vefat Duyuruları',
    description: 'Vefat eden hemşehrilerimiz için taziye duyurusu hazırlanması, taziye yeri bilgisinin paylaşılması ve ailelere dayanışma desteği sağlanması konusunda yardımcı oluyoruz.',
    tags: ['Taziye', 'Vefat duyurusu', 'Dayanışma']
  },
  {
    icon: 'fa-calendar-check',
    title: 'Düğün, Nişan ve Özel Gün Duyuruları',
    description: 'Hemşehrilerimizin düğün, nişan, mevlit, toplantı ve özel günlerini dernek çevresine duyurarak katılımı ve hemşehri bağını güçlendiriyoruz.',
    tags: ['Düğün', 'Nişan', 'Duyuru']
  },
  {
    icon: 'fa-user-graduate',
    title: 'Öğrenci ve Ev Arkadaşı Ağı',
    description: 'Ankara’da okuyan Ağrılı öğrenciler için güvenilir çevre, yurt, ev arkadaşı, burs yönlendirmesi ve eğitim desteği konularında iletişim ağı oluşturuyoruz.',
    tags: ['Öğrenci', 'Burs', 'Ev arkadaşı']
  },
  {
    icon: 'fa-building-columns',
    title: 'Resmi Kurum ve İşlem Yönlendirmesi',
    description: 'Ankara’ya yeni gelen veya resmi işlemlerinde yol gösterici bilgi arayan hemşehrilerimizi doğru kurum, doğru adres ve güvenilir danışmanlarla buluşturuyoruz.',
    tags: ['Resmi işlemler', 'Yönlendirme', 'Ankara']
  },
  {
    icon: 'fa-truck-medical',
    title: 'Acil Durum ve Hastane Dayanışması',
    description: 'Hastane, refakat, kan ihtiyacı ve acil dayanışma gerektiren durumlarda hemşehrilerimizin daha hızlı destek bulabilmesi için iletişim kanallarımızı kullanıyoruz.',
    tags: ['Hastane', 'Kan ihtiyacı', 'Acil destek']
  },
  {
    icon: 'fa-handshake',
    title: 'Esnaf Arası İş Birliği',
    description: 'Ağrılı esnaflar arasında güvenilir tedarik, müşteri yönlendirme, usta-hizmet tavsiyesi ve ortak çalışma kültürünü geliştirerek ekonomik dayanışmayı büyütüyoruz.',
    tags: ['Esnaf', 'İş birliği', 'Ticaret']
  },
  {
    icon: 'fa-ticket',
    title: 'Bilet, Yolculuk ve Memleket Bağlantısı',
    description: 'Ankara’dan Ağrı’ya, Doğubayazıt’a, Patnos’a veya diğer ilçelerimize yolculuk planlayan hemşehrilerimizin otobüs firmaları, sefer bilgisi ve güvenilir ulaşım bağlantılarına daha kolay ulaşmasını hedefliyoruz.',
    tags: ['Ağrı bilet', 'Otobüs', 'Memleket']
  },
  {
    icon: 'fa-coins',
    title: 'Ticaret, Kazanç ve Yatırım Dayanışması',
    description: 'Çalışmayı, üretmeyi ve para kazanmayı seven hemşehrilerimiz için firma tanıtımı, müşteri yönlendirme, iş ortaklığı, yatırım fikri ve güvenilir ticaret bağlantılarını güçlendirmeye çalışıyoruz.',
    tags: ['Ticaret', 'Kazanç', 'Yatırım']
  }
]

const generalWhatsappUrl = `https://wa.me/905079217404?text=${encodeURIComponent('Derneğinize websitesinden katıldım, hizmetleriniz hakkında bilgi almak istiyorum.')}`

const whatsappUrl = (serviceTitle) => {
  const message = `Derneğinize websitesinden katıldım, ${serviceTitle} hizmeti hakkında bilgi almak istiyorum.`
  return `https://wa.me/905079217404?text=${encodeURIComponent(message)}`
}
</script>

<style scoped>
.services-page {
  background: linear-gradient(180deg, #fff 0%, #f7fafc 48%, #fff 100%);
}

.services-hero {
  padding: 58px 0 28px;
}

.services-hero-grid {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 310px;
  gap: 32px;
  align-items: end;
}

.services-hero h1 {
  color: var(--dark);
  font-size: clamp(34px, 5vw, 58px);
  line-height: 1.08;
  max-width: 980px;
  margin: 0 0 18px;
}

.services-hero p {
  color: #5b6475;
  font-size: 18px;
  line-height: 1.75;
  max-width: 940px;
  margin: 0;
}

.services-contact-card {
  display: grid;
  gap: 12px;
  background: var(--dark);
  border-left: 5px solid var(--primary);
  border-radius: 8px;
  padding: 24px;
  box-shadow: 0 18px 38px rgba(15, 23, 43, .14);
}

.services-contact-card span {
  color: rgba(255, 255, 255, .72);
  font-size: 13px;
  font-weight: 900;
  text-transform: uppercase;
}

.services-contact-card strong {
  color: #fff;
  font-size: 25px;
  font-weight: 900;
}

.seo-keywords {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 24px;
}

.seo-keywords span,
.service-tags span {
  color: #344054;
  background: #fff;
  border: 1px solid rgba(15, 23, 43, .08);
  border-left: 3px solid var(--primary);
  border-radius: 999px;
  font-size: 13px;
  font-weight: 800;
  padding: 8px 12px;
}

.services-main {
  padding: 24px 0 34px;
}

.search-intent-section {
  padding: 0 0 76px;
}

.intent-panel {
  display: grid;
  grid-template-columns: minmax(0, .85fr) minmax(0, 1.15fr);
  gap: 28px;
  align-items: start;
  background: #fff;
  border: 1px solid rgba(15, 23, 43, .08);
  border-left: 4px solid var(--primary);
  border-radius: 8px;
  padding: 28px;
  box-shadow: 0 14px 35px rgba(15, 23, 43, .08);
}

.intent-panel h2 {
  color: var(--dark);
  font-size: 28px;
  line-height: 1.18;
  margin-bottom: 14px;
}

.intent-panel p {
  color: #5f6979;
  line-height: 1.72;
  margin: 0;
}

.intent-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.intent-grid span {
  color: #344054;
  background: #f8fafc;
  border: 1px solid rgba(15, 23, 43, .08);
  border-radius: 999px;
  font-size: 13px;
  font-weight: 800;
  padding: 8px 11px;
}

.services-layout {
  display: grid;
  grid-template-columns: 320px minmax(0, 1fr);
  gap: 28px;
  align-items: start;
}

.services-side {
  position: sticky;
  top: 112px;
  background: #fff;
  border: 1px solid rgba(15, 23, 43, .08);
  border-radius: 8px;
  padding: 26px;
  box-shadow: 0 14px 35px rgba(15, 23, 43, .08);
}

.services-side h2 {
  color: var(--dark);
  font-size: 24px;
  margin-bottom: 12px;
}

.services-side p {
  color: #606a7a;
  line-height: 1.7;
}

.district-links {
  display: grid;
  gap: 8px;
  margin-top: 18px;
}

.district-links a {
  color: var(--dark);
  background: #f8fafc;
  border: 1px solid rgba(15, 23, 43, .08);
  border-radius: 8px;
  font-weight: 800;
  padding: 11px 13px;
}

.district-links a:hover {
  color: var(--primary);
  background: #fff9ef;
  border-color: rgba(254, 161, 22, .36);
}

.services-list {
  display: grid;
  gap: 14px;
}

.service-card {
  display: grid;
  grid-template-columns: 58px minmax(0, 1fr) auto;
  gap: 18px;
  align-items: start;
  background: #fff;
  border: 1px solid rgba(15, 23, 43, .08);
  border-left: 4px solid var(--primary);
  border-radius: 8px;
  padding: 20px;
  box-shadow: 0 10px 28px rgba(15, 23, 43, .06);
}

.service-icon {
  width: 50px;
  height: 50px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  background: var(--primary);
  border-radius: 8px;
  font-size: 21px;
}

.service-content h2 {
  color: var(--dark);
  font-size: 23px;
  margin: 0 0 8px;
}

.service-content p {
  color: #5f6979;
  line-height: 1.65;
  margin: 0;
}

.service-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 7px;
  margin-top: 13px;
}

.service-action {
  min-height: 44px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  color: #fff;
  background: #25d366;
  border-radius: 4px;
  font-weight: 900;
  padding: 10px 14px;
  white-space: nowrap;
}

.service-action:hover {
  color: #fff;
  background: #1ead54;
}

@media (max-width: 991.98px) {
  .services-hero-grid,
  .services-layout,
  .service-card,
  .intent-panel {
    grid-template-columns: 1fr;
  }

  .services-side {
    position: static;
  }
}

@media (max-width: 575.98px) {
  .services-page {
    padding-bottom: 86px;
  }

  .services-hero {
    padding-top: 38px;
  }

  .services-hero h1 {
    font-size: 32px;
  }

  .services-hero p {
    font-size: 16px;
  }

  .services-contact-card,
  .service-card,
  .services-side {
    padding: 18px;
  }

  .service-action {
    width: 100%;
  }
}
</style>
